module.exports = __webpack_public_path__ + "img/manchester-city.3fa72e8c.png";